import { IconButton, Stack, Tooltip } from '@mui/material';
import type { Snapshot, InventoryResource } from '@repo/api-gw-sdk';

import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';
import { AuthorizationTooltip } from '@/components/tooltips/authorizationTooltip';
import { useRoles } from '@/contexts/useRoles';

import type { MutateSnapshots } from './eonSnapshotsTab';
import { SnapshotOptionMenu } from './snapshotOptionMenu';

interface SnapshotActionsGroupProps {
  isVisible: boolean;
  onRestore?: () => void;
  convertSnapshot?: {
    title: string;
    onConvertSnapshot: () => void;
  };
  resource: InventoryResource;
  snap?: Snapshot;
  mutateSnapshots: MutateSnapshots;
}

export const SnapshotActionsGroup = (props: SnapshotActionsGroupProps) => {
  const {
    isVisible,
    resource,
    convertSnapshot,
    onRestore,
    snap,
    mutateSnapshots,
  } = props;
  const { isAuthorizedResource } = useRoles();

  const isAuthorized = isAuthorizedResource(
    'create:restore_resource',
    resource
  );

  return (
    <Stack
      height='32px'
      direction='row'
      alignItems='center'
      className='flex justify-end'
    >
      <Stack direction='row' alignItems='center' gap='12px'>
        {isVisible && (
          <Stack direction='row' alignItems='center' gap='12px'>
            {convertSnapshot && (
              <Tooltip title={convertSnapshot.title}>
                <div>
                  <IconButton
                    data-testid='convert-button'
                    disabled={!isAuthorized}
                    onClick={convertSnapshot.onConvertSnapshot}
                    className={'mr-[10px]'}
                  >
                    <i className='material-symbols-repeat-rounded text-[20px] text-(--mui-palette-text-primary)' />
                  </IconButton>
                </div>
              </Tooltip>
            )}
            {onRestore && (
              <AuthorizationTooltip isAuthorized={isAuthorized}>
                <ButtonWithIcon
                  text='Restore'
                  disabled={!isAuthorized}
                  variant='outlined'
                  onClick={onRestore}
                  icon='material-symbols-settings-backup-restore-rounded'
                />
              </AuthorizationTooltip>
            )}
          </Stack>
        )}
        {snap && (
          <SnapshotOptionMenu
            snap={snap}
            mutateSnapshots={mutateSnapshots}
            resource={resource}
          />
        )}
      </Stack>
    </Stack>
  );
};
